export const formatNumber = (num) => {
  if (num === null || num === undefined || num === "") return "0";
  return new Intl.NumberFormat("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};
